export default "__VITE_ASSET__tc5aVhoT__"